import React from 'react';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { MdWifiOff } from 'react-icons/md';
const OfflineIndicator = ({ isOnline, pendingCount, onSync, syncStatus }) => {
  if (isOnline && pendingCount === 0) return null;

  return (
    <div className={`fixed bottom-4 right-4 p-4 rounded-lg shadow-lg z-50 ${
      isOnline ? 'bg-yellow-100 border border-yellow-300' : 'bg-red-100 border border-red-300'
    }`}>
      <div className="flex items-center space-x-3">
        {!isOnline && <MdWifiOff className="text-red-600" />}
        <div>
          <div className="font-medium text-sm">
            {!isOnline ? '离线模式' : '有待同步数据'}
          </div>
          {pendingCount > 0 && (
            <div className="text-xs text-gray-600">
              {pendingCount} 条记录待上传
            </div>
          )}
        </div>
        {isOnline && pendingCount > 0 && (
          <button
            onClick={onSync}
            disabled={syncStatus === 'syncing'}
            className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700 disabled:opacity-50 flex items-center"
          >
            <FaCloudUploadAlt className="mr-1" />
            {syncStatus === 'syncing' ? '同步中' : '同步'}
          </button>
        )}
      </div>
    </div>
  );
};

export default OfflineIndicator;